<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- old password -->
        <b-col md="6">
          <b-form-group
            label="Old Password"
            label-for="account-old-password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-old-password"
                v-model="passwordValueOld"
                name="old-password"
                :type="passwordFieldTypeOld"
                placeholder="Old Password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconOld"
                  class="cursor-pointer"
                  @click="togglePasswordOld"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ old password -->
      </b-row>
      <b-row>
        <!-- new password -->
        <b-col md="6">
          <b-form-group
            label-for="account-new-password"
            label="New Password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="newPasswordValue"
                :type="passwordFieldTypeNew"
                name="new-password"
                placeholder="New Password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ new password -->

        <!-- retype password -->
        <b-col md="6">
          <b-form-group
            label-for="account-retype-new-password"
            label="Retype New Password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-retype-new-password"
                v-model="RetypePassword"
                :type="passwordFieldTypeRetype"
                name="retype-password"
                placeholder="New Password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconRetype"
                  class="cursor-pointer"
                  @click="togglePasswordRetype"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ retype password -->

        <!-- password rule hint -->
        <b-col cols="12">
          <small class="text-muted">
            {{ ru ? 'Минимум 8 символов: цифра, строчная и заглавная буква, спецсимвол.'
              : 'At least 8 characters: a digit, a lowercase and an uppercase letter, a special character.' }}
          </small>
        </b-col>

        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            :disabled="!isFilled || loading"
            @click="changePassword()"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            Save changes
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            class="mt-1"
            :disabled="loading"
            @click="resetForm()"
          >
            Reset
          </b-button>
        </b-col>
        <!--/ buttons -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/cubus/jwt/useJwt'

// Same rule the backend enforces (AuthHandler.validatePassword) and the password-reset form uses.
const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      loading: false,
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    ru() {
      return this.$i18n && this.$i18n.locale === 'ru'
    },
    isFilled() {
      // The old password used to be missing from this check, so the form happily submitted an
      // empty one — and the API answered 200 OK to it.
      return !!(this.passwordValueOld && this.newPasswordValue && this.RetypePassword)
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    toast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
          text,
        },
      })
    },
    error(text) {
      this.toast('danger', this.ru ? 'Ошибка' : 'Error', text)
    },
    resetForm() {
      // `type="reset"` only cleared the DOM inputs — the v-model values stayed behind.
      this.passwordValueOld = ''
      this.newPasswordValue = ''
      this.RetypePassword = ''
    },
    validate() {
      if (this.newPasswordValue !== this.RetypePassword) {
        return this.ru ? 'Пароли не совпадают' : 'Passwords do not match'
      }
      if (!PASSWORD_PATTERN.test(this.newPasswordValue)) {
        return this.ru
          ? 'Пароль должен быть не менее 8 символов и содержать цифру, строчную и заглавную буквы, спецсимвол'
          : 'Password must be at least 8 characters long and contain a digit, a lowercase and an uppercase letter, a special character'
      }
      if (this.newPasswordValue === this.passwordValueOld) {
        return this.ru ? 'Новый пароль должен отличаться от текущего' : 'New password must differ from the current one'
      }
      return null
    },
    changePassword() {
      const invalid = this.validate()
      if (invalid) {
        this.error(invalid)
        return
      }
      this.loading = true
      useJwt.changePassword({
        token: useJwt.getCubusToken(),
        oldpass: this.passwordValueOld,
        newpass: this.newPasswordValue,
        retype: this.RetypePassword,
      })
        .then(() => {
          // The password change drops every other session of this user, so warn about it.
          this.toast(
            'success',
            this.ru ? 'Готово' : 'Done',
            this.ru
              ? 'Пароль изменён. Остальные ваши сессии завершены.'
              : 'Password changed. Your other sessions have been closed.',
          )
          this.resetForm()
        })
        .catch(err => {
          // The API answers 400/401/429 with {"error": "..."} — show it instead of swallowing it.
          const res = err.response
          const text = (res && res.data && res.data.error)
            || (this.ru ? 'Не удалось изменить пароль' : 'Failed to change the password')
          this.error(text)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
